var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.619048 0h8.380952v11.428571h-8.380952z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.333333v11.428571h-5.333333z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.571429 0h6.857143v11.428571h-6.857143z",
    fill: "url(#a)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.89461844 5.58157203.49647741-.49647739c.0729283-.0729283.19428906-.07113827.27024625.00481886l.2434198.24341983.7619048-.38095238-.3809524.76190476.2434198.24341984c.0780088.07800874.078837.19622813.0064323.26863279l-1.01175688 1.0117569h-1.14285714l-.19047619 1.14285714h-.38095238l-.19047619-1.14285714h-1.14285714l-1.0117569-1.0117569c-.06965529-.06965528-.06952483-.19267567.0064323-.26863279l.24341983-.24341984-.38095238-.76190476.76190477.38095238.24341983-.24341983c.07800874-.07800874.19695048-.07811461.27024623-.00481886l.49647739.49647739c.0729283.0729283.11573637.04782708.09479378-.05688585l-.34303247-1.71516237.76190476.38095238.38095238-1.14285714.38095238 1.14285714.76190476-.38095238-.34303245 1.71516237c-.02155086.10775429.02149798.1301816.09479375.05688585z",
    fill: "url(#c)",
    mask: "url(#d)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.96e9772ad3c02ca098f6fe80f64fec88.svg";
export { ForwardRef as ReactComponent };